import React, { useEffect, useState } from 'react'
import classes from "../../styles.module.css";
import { useNavigate } from 'react-router-dom';
import TitleSection from '../../../../common/TitleSection';
import { Helmet } from 'react-helmet';
import { FullWidthWiraaAds } from '../../../../common/Ads/FullWidthWiraaAds';
import styles from "../../../../ContentStyling.module.css";

const CmToYard = () => {
    const [inputValue, setInputValue] = useState();
    const [outputValue, setOutputValue] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        // Initialize Google Ads
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          console.error("AdSense run successfully");
        } catch (e) {
          console.error("AdSense error", e);
        }
      }, []);

      const convertCmToYard = () => {
        // Validate input: allow numbers, decimals, and optional minus sign
        if (!/^-?\d+(\.\d+)?$/.test(inputValue)) {
            setErrorMessage("Please enter a valid length in centimeters (e.g., 91.44, 200).");
            setOutputValue("");
            return;
        }

        setErrorMessage("");
        const cmValue = parseFloat(inputValue); // Convert input string to a number
        const yardValue = cmValue / 91.44; // 1 yard = 91.44 cm
        setOutputValue(yardValue.toFixed(6)); // Limit output to 6 decimal places
    };







      const handleClearBtn = () => {
        setInputValue("");
        setOutputValue("");
        setErrorMessage("");
      }

      const handleSwapClick = () => {
        navigate("/converters/yard-to-cm");
    };

        

  return (
    <div className={classes.page}>
      <Helmet>
                <title>CM to Yard Converter - Wiraa tools</title>
                <meta name="description" content="Easily convert Cm to Yard using our online conversion tool. Accurate results with simple calculations for your length measurements. Try now!" />
        </Helmet>
    <div className={classes.container}>
                  <TitleSection
                    icon="https://cdn-icons-png.flaticon.com/128/570/570968.png"
                    title="CM To Yard Converter"
                    subTitle="Effortlessly Convert CM To Yard for Accurate Measurements"
                  />
      <div className={classes.innerCon}>
        <div className={classes.inputCon}>
            <p className={classes.inputplaceholder}>CM Value</p>
            <input value={inputValue} onChange={(e) => setInputValue(e.target.value)} className={classes.inputfield} placeholder='Enter cm value'/>
            {errorMessage && <p className={classes.errorMsg}>{errorMessage}</p>}
        </div>
        <div className={classes.btnCon}>
            <button className={classes.convertBtn} onClick={convertCmToYard}>Convert</button>
            <button className={classes.clearBtn} onClick={handleClearBtn}>Clear</button>
            <button className={classes.swapBtn} onClick={handleSwapClick}>Swap</button>
        </div>
        <div className={classes.outputCon}>
            <p className={classes.outputplaceholder}>Yard Value</p>
            <p className={classes.outputfield}>{outputValue}</p>
        </div>
      </div>
      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>
     <div className={styles.contentContainer}>
      <p>The CM to Yards Converter is a must-have tool for professionals, students, and anyone working with international length measurements. It allows you to quickly convert centimeters (CM), the metric unit, into yards (YD), commonly used in the U.S. and U.K. for measuring fabrics, land, and more.</p>
      <p>This tool ensures accurate conversions, helping you communicate and calculate measurements confidently across global standards.</p>
      <h3>What Are CM and Yards?</h3>
      <p><b>Centimeters (CM): </b>A unit of length in the metric system. 1 cm = 0.01 meters. Used worldwide in science, engineering, and daily life.</p>
      <p><b>Yards (YD): </b> A unit of length in the imperial system. 1 yard = 36 inches or 3 feet. Commonly used in construction, real estate, and textiles.</p>
      <p><b>Conversion Rule:</b> cm = 0.0109361 yards</p>
      <h3>Why Convert CM to Yards?</h3>
      <ul>
        <li><b>International Use:</b> Yards are often used in the U.S. and U.K., while CM is common elsewhere.</li>
        <li><b>Tailoring & Textiles:</b> Yards are standard in fabric and clothing measurements.</li>
        <li><b>Construction:</b> Building plans and materials often require imperial-to-metric conversions.</li>
      </ul>
      <h3>How to Use the CM to Yards Converter</h3>
      <ol>
        <li><b>Input CM Value:</b> Type the centimeter value into the field.</li>
        <li><b>Click Convert:</b> Instantly see the result in yards.</li>
        <li><b>Copy the Output:</b> Use the yard value in your blueprints, measurements, or purchases.</li>
      </ol>
      <h3>Conversion Examples</h3>
      <ul>
        <li>1 cm → 0.0109 yd</li>
        <li>50 cm → 0.5468 yd</li>
        <li>91.44 cm → 1 yd</li>
        <li>200 cm → 2.1872 yd</li>
      </ul>
      <h3>Benefits of Using CM to Yards Converter</h3>
      <ul>
        <li><b>Instant & Accurate:</b> Converts with precision using the standard conversion factor.</li>
        <li><b>No Manual Math:</b> Eliminates errors and saves time.</li>
        <li><b>User-Friendly:</b> Simple interface for fast results.</li>
      </ul>
      <h3>Why Choose This Converter?</h3>
      <p>Whether you’re buying fabric, building a space, or studying measurements, this tool is built to meet your needs with speed and accuracy. Best for:</p>
      <ul>
        <li><b>Architects & Contractors:</b> For imperial-to-metric conversions on-site.</li>
        <li><b>Designers & Tailors:</b> To work with international sizing and fabric units.</li>
        <li><b>Educators & Students:</b> For science and math projects involving unit conversions.</li>
      </ul>
     </div>
    </div>
   </div>
  )
}

export default CmToYard;
